import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Heading } from "src/components";
import { UserTable } from "./containers";

export const UserManagement: FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Heading level={1}>{t("userManagement.title")}</Heading>
            <UserTable />
        </>
    );
};
